import React from 'react'
import styled from 'styled-components'

const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-menu"
    >
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  )
}

const Menu = ({ showMenu, setShowMenu }) => {
  return (
    <Wrapper className="menu-toggle" onClick={() => setShowMenu(!showMenu)}>
      <span className="u-sr-only">Menu</span>
      <MenuIcon />
    </Wrapper>
  )
}

const Wrapper = styled.button`
  color: var(--color-text1);
  background: none;
  border: none;
  cursor: pointer;
  transition: opacity 250ms;

  &:hover {
    opacity: 0.7;
  }
`

export default Menu
